<template>
  <div v-loading.fullscreen.lock="isLoading">
    <div>
      <el-form ref="form" :model="addForm">
        <div style="margin-left: 7em; margin-right: 7em">
          <el-row>
            <el-form-item
              label="使用者名稱"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <el-input
              style="margin-bottom: 1em"
              placeholder="請輸入使用者名稱"
              v-model="addForm.title"
              :disabled="this.addForm.username=='admin'||this.addForm.username=='personAdmin'"
            ></el-input>

            <el-form-item
              label="帳號"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <el-input
              :disabled="!isNaN(this.id)"
              style="margin-bottom: 1em"
              placeholder="請輸入帳號(不能有中文、不分大小寫)"
              v-model="addForm.username"
            ></el-input>

            <el-form-item 
              label="新密碼" 
              required
              style="margin-bottom: -1em">
            </el-form-item>
             <el-input
              style="margin-bottom: 1em"
              clearable
              placeholder="請輸入密碼(不能有中文)"
              v-model="addForm.password"
              auto-complete="new-password"
              type="password"
            ></el-input>

            <el-form-item 
              label="確認密碼" 
              required
              style="margin-bottom: -1em">
            </el-form-item>
             <el-input
              style="margin-bottom: 1em"
              clearable
              placeholder="請再次輸入密碼"
              v-model="passwordC"
              auto-complete="new-password"
              type="password"
            ></el-input>

             <el-form-item
              label="角色"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <el-select
              multiple
              v-model="addForm.role"
              placeholder="請選擇角色"
              style="display: block; width: 100%; margin-bottom: 1em"
              :disabled="this.addForm.username=='admin'||this.addForm.username=='personAdmin'"
            >
             <el-option key="admin" label="系統管理員" value="ROLE_ADMIN"></el-option>
             <el-option key="user" label="使用者" value="ROLE_USER"></el-option>
             <el-option key="personAdmin" label="人員資料管理員" value="ROLE_PERSON_ADMIN"></el-option>
            </el-select>
          </el-row>
          <br />

          <el-row type="flex" justify="center">
            <el-button @click="closeDialog">取消</el-button>
            <el-button
              v-if="!isNaN(this.id)"
              @click="check()"
              type="primary"
              >儲存</el-button> 
            <el-button
              v-else
              @click="check()"
              type="primary"
              >新增</el-button>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import API from "@/api/";
import Utils from "@/utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "lifeClassAdd",
  props: {
    clickTime: Date,
    id: { Number, default: NaN },
  },
  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.id);
      this.query();
    },
  },
  created: function () {
    this.passwordEite= false,
    this.passwordC= "",
    this.query();
  },
  data() {
    return {
      isLoading: false,
      passwordC:"",
      addForm: {
        title: "",
        username: "",
        password: "",
        role: "",
      },
    };
  },
  methods: {
    query() {
      if (this.id) {
        console.log("讀取");
        this.isLoading = true;
        API.user.show(this.id).then((res) => {
          console.log(res);
          this.addForm=res.data;
          this.addForm.password= "",
          this.addForm.role = res.data.role.map((it)=>{
            return it.authority;});
          this.isLoading = false;
        });
      } else {
        this.addForm ={
          title: "",
          username: "",
          password: "",
          role: "",
        };
      }
    },
    closeDialog() {
      this.passwordEite= false;
      this.passwordC="";
      this.$emit("close");
    },
    check() {
      let rules = new RegExp(/^[\u4e00-\u9fa5]+$/);
      if (Utils.Check.isNull(this.addForm.title)) {
        Utils.Message.send("使用者名稱不能為空!", InformType.ERROR);
        return;} 

      if (Utils.Check.isNull(this.addForm.username)) {
        Utils.Message.send("帳號不能為空!", InformType.ERROR);
        return;} 

      if (rules.test(this.addForm.username)) {
        Utils.Message.send("帳號格式錯誤!", InformType.ERROR);
        return;} 
      
      if (isNaN(this.id) && Utils.Check.isNull(this.addForm.password)) {
        Utils.Message.send("密碼不能為空!", InformType.ERROR);
        return;} 

      if (rules.test(this.addForm.password)&& !Utils.Check.isNull(this.addForm.password)) {
        Utils.Message.send("密碼格式錯誤!", InformType.ERROR);
        return;} 

      if (Utils.Check.isNull(this.addForm.role)) {
        Utils.Message.send("角色不能為空!", InformType.ERROR);
        return;} 

      if (this.addForm.password!=this.passwordC) {
        Utils.Message.send("確認密碼不符合!請重新輸入!", InformType.ERROR);
        return;} 
        
     
      console.log("檢查成功");
      //去空白
      this.addForm.title = this.addForm.title.replaceAll(/\s+/g, "");
      this.addForm.username = this.addForm.username.replaceAll(/\s+/g, "");
      this.addForm.password = this.addForm.password.replaceAll(/\s+/g, "");
      this.update(); 
    },

    update() {
      if (this.id) {
        console.log("修改", this.addForm.username, this.addForm);
        this.isLoading = true;
        API.user
          .update(this.addForm.username, this.addForm)
          .then(() => {
            Utils.Message.send("修改帳號成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        console.log("新增");
        this.isLoading = true;
        API.user
          .add(this.addForm)
          .then(() => {
            Utils.Message.send("新增帳號成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style>
</style>